import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import * as ClearancePermitListState from '../state/ClearancePermitListState.ts';

export const selectPermit = (
    store: Flux.Store,
    contractExternalId: string,
): string => {
    new ClearancePermitListState.StateSlice(store).selectPermit(
        contractExternalId,
    );
    return 'ClearenacePermitListActions-selectPermit';
};

export const selectClearance = (
    store: Flux.Store,
    contractExternalId: string,
): string => {
    new ClearancePermitListState.StateSlice(store).selectClearance(
        contractExternalId,
    );
    return 'ClearenacePermitListActions-selectClearance';
};
